import { Injectable } from '@angular/core';
import { EntityStateStore } from '@shared/store/entity-state-store';
import { DeviceEntity } from '@/app/platform/platform-data/models/device.entity';

@Injectable({ providedIn: 'root' })
export class DeviceEntityStore extends EntityStateStore<DeviceEntity> {
  constructor() {
    super();
  }
}
